import { FormInstanceOperationsDialog } from "../form-instance-operations.dialog";
export class BaseFormInstanceOperation {
    // Defaults
    public performAutomatically: boolean = false;
    public dismissButtonTitle: string = 'Done';
    public showElapsedTime: boolean = true;
    public alwaysShowLog: boolean = false;

    protected dialog: FormInstanceOperationsDialog;

    constructor(dialog: FormInstanceOperationsDialog) {
        this.dialog = dialog;
    }

    public dismissDialog(): void {
        // NOOP
    }

    public disableDismissButton(): boolean {
        return false;
    }

    public get UserNoLongerAccessToFormInstance(): boolean {
        return false;
    }

}
